module.exports = __webpack_public_path__ + "img/sierras_8ko.7759347.jpg";